export const GROUP_CONTEXT = Symbol();

export type GroupContext<T> = {
	/** Funciton to toggle select or deslect on a item */
	select: (value: T) => void;
	/** Function to listen for changes to the group  */
	register: (valuesListener: (values: T[]) => void) => void;
	/** Optional utility function to assign a unique value for each item in the group */
	nextIndex: () => number;
	/** Let children component if the group is in multiple select mode */
	multiple: boolean;
};
